import { IS_LOCAL_DEV_SERVER, SST_API_URL } from '@/common/env'

// Deliberately IS_LOCAL_DEV_SERVER, not the wider IS_DEV: the `/bff` path only resolves
// because vite.config.ts's dev-server proxy rewrites it to the real API host during
// `yarn dev`. A deployed build — including the dev stage, where IS_DEV is also true — serves
// static files with no such proxy, so it must hit the real API host directly like every
// other stage.
export const BFF_BASE_URL = IS_LOCAL_DEV_SERVER ? '/bff' : SST_API_URL
